// Config
import { BACKEND_API } from "@/project.config";

interface PasswordResetResponse {
  success: boolean;
  message?: string;
  data?: any;
}

export async function passwordReset(
  email: string
): Promise<PasswordResetResponse> {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 segundos de timeout

    const res = await fetch(`${BACKEND_API}/auth/token/${email}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!res.ok) {
      return {
        success: false,
        message: `Error en la petición: ${res.status} ${res.statusText}`,
      };
    }

    const data = await res.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    if (error.name === "AbortError") {
      return {
        success: false,
        message: "La petición ha excedido el tiempo de espera",
      };
    }
    if (error.name === "TypeError" && error.message === "Failed to fetch") {
      return {
        success: false,
        message:
          "Error de conexión. Por favor, verifica tu conexión a internet",
      };
    }
    return {
      success: false,
      message: "Ha ocurrido un error inesperado",
    };
  }
}
